import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f8423d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { style: {"height":"37px","display":"block","margin-top":"12px"} }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "text-center mt-4 mb-5" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Composition Percentage",
          text: "Edit Composition Percentage"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Composition Part",
                text: "Composition Part"
              })
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Percentage",
            labelValue: "Percentage",
            placeholderKey: "Percentage",
            placeholderValue: "Percentage",
            modelValue: _ctx.localPercentage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localPercentage) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("p", _hoisted_12, [
        _createVNode(_component_localized_text, {
          localizedKey: "**Be careful, by editing this value, each percentage composition will be recalculated",
          text: "**Be careful, by editing this value, each percentage composition will be recalculated"
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save",
            text: "Save"
          })
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}